var Vue = require('vue');
var helpers = require('../../helpers');
var autocomplete = require('./../autocomplete');
var address = require('./../address/address');
var validation = require('./../validation');
require('./app');
require('./contactservice');

(function (controllers, undefined) {

    controllers.ContactApp = new Vue({
        el: '#contact-app',
        data: {
            IsBrochureRequest: false,
            Valid: true,
            ValidationMessages: [],
            Contact: {
                FirstName: '',
                LastName: '',
                EmailAddress: '',
                Comment: '',
                Address: {
                    StreetAddress1: '',
                    StreetAddress2: '',
                    City: '',
                    StateId: '',
                    ZipCode: '',
                    CountryId: ''
                }
            },
            modal: {
                success: true,
                message: '',
                link:''
            },
            formitems: {
                address: {
                    name: 'Address.StreetAddress1',
                    required: true,
                    value: '',
                    valid: true,
                    validationmessage: '',
                    minlength: 1,
                    maxlength: 100
                },

                country: {
                    name: 'Address.CountryId',
                    allcountries: [],
                    value: '',
                    required: true,
                    valid: true,
                    validationmessage: '',
                    minlength: 2,
                    maxlength: 2
                },

                state: {
                    name: 'Address.StateId',
                    allstates: [],
                    value: '',
                    search: [],
                    searchvalue: '',
                    required: true,
                    valid: true,
                    validationmessage: '',
                    minlength: 2,
                    maxlength: 50
                },

                city: {
                    name: 'Address.City',
                    allvalues: [],
                    value: '',
                    search: [],
                    searchvalue: '',
                    arrowcounter: -1,
                    isopen: false,
                    required: true,
                    validationmessage: '',
                    valid: true,
                    minlength: 1,
                    maxlength: 75
                },

                zipcode: {
                    name: 'Address.ZipCode',
                    allvalues: [],
                    value: '',
                    search: [],
                    searchvalue: '',
                    arrowcounter: -1,
                    isopen: false,
                    required: true,
                    validationmessage: '',
                    valid: true,
                    minlength: 1,
                    maxlength: 50
                }
            }
        },
        mounted: function () {
            this.init();
        },
        methods: {
            init: function init() {


                var isBrochure = helpers.getParameterByName('brochure');

                //if brochure requested, set-up address
                if (isBrochure) {
                    this.formitems.country.value = 'US';
                    address.getCountries(this.formitems.country);
                    address.getStates(this.formitems.state);
                    this.IsBrochureRequest = true;
                } 
            },

            validate: function validate() {

                var self = this;

                var emailObj = {};

                self.ValidationMessages = [];
                self.Valid = true;

                if (self.Contact.FirstName.length === 0) {
                    self.ValidationMessages.push('First Name is required');
                }
                if (self.Contact.LastName.length === 0) {
                    self.ValidationMessages.push('Last Name is required');
                }
                if (self.Contact.EmailAddress.length === 0) {
                    self.ValidationMessages.push('Email Address is required');
                } else {

                    emailObj.value = self.Contact.EmailAddress;
                    validation.validateEmail(emailObj);
                }
                if (!self.IsBrochureRequest) {
                    if (self.Contact.Comment.length === 0) {
                        self.ValidationMessages.push('Please enter a comment or question');
                    }
                } else {

                    validation.validateRequired(self.formitems.address);

                    //if US country, validate city and zipcode
                    if (self.formitems.country.value === 'US') {
                        validation.validateRequired(self.formitems.city);
                        validation.validateCity(self.formitems.city);
                        validation.validateRequired(self.formitems.zipcode);
                        validation.validateZipCode(self.formitems.zipcode);
                    }
                } 

                //check honeypot
                if ($('#contact_by_fax').val() !== '' || $('#contact_by_telegraph').val() !== 'alien') {
                    self.ValidationMessages.push('Sorry, we could not submit your request.');
                }

                if (!self.formitems.address.valid ||
                    !self.formitems.city.valid ||
                    !self.formitems.zipcode.valid ||
                    !emailObj.valid ||
                    self.ValidationMessages.length > 0) {

                    self.Valid = false;

                    return false;
                }
                return true;
            },
            submit: function submit() {

                var self = this;

                if (self.validate() === true) {

                    var token = $('input[name="__RequestVerificationToken"]').val();

                    if (self.IsBrochureRequest) {

                        self.Contact.Address.StreetAddress1 = self.formitems.address.value;
                        self.Contact.Address.City = self.formitems.city.value;
                        self.Contact.Address.StateId = self.formitems.state.value;
                        self.Contact.Address.ZipCode = self.formitems.zipcode.value;
                        self.Contact.Address.CountryId = self.formitems.country.value;

                        Contact.Services.ContactService.postBrochureRequest(self.Contact, token).then(function (data) {

                            if (data.userMessage && data.userMessage.length > 0) {
                                self.modal.success = true;
                                self.modal.message = data.userMessage;
                            } else {
                                self.modal.success = false;
                                self.modal.message = 'We were unable to process your request. Site administrators have been notified. If you continue encountering difficulty, please email us at AnglerRecognition@MyFWC.com';
                            }

                            self.modal.link = '/programs/life-list/';
                        });
                    } else {
                        Contact.Services.ContactService.postContact(self.Contact, token).then(function (data) {

                            if (data.userMessage && data.userMessage.length > 0) {
                                self.modal.success = true;
                                self.modal.message = data.userMessage;
                            } else {
                                self.modal.success = false;
                                self.modal.message = 'We were unable to process your request. Site administrators have been notified. If you continue encountering difficulty, please email us at AnglerRecognition@MyFWC.com';
                            }

                            self.modal.link = '/';
                        });
                    }
                    $('#modal').modal();
                }
            },

            ////////
            //////
            //  ADDRESS FUNCTIONALITY
            //////
            ////////

            //user has changed the city selection from dropdown
            countryChange: function countryChange() {

                var self = this;

                address.countryChange(self.formitems.country.value, self.formitems.state, self.formitems.city, self.formitems.zipcode);
            },
            //user has changed the state selection from dropdown
            stateChange: function stateChange() {

                var self = this;

                address.stateChange(self.formitems.city, self.formitems.state.value, self.formitems.zipcode);
            },

            //////
            //  EVENT HANDLERS - AUTO COMPLETE

            autoCompleteSetResult: function autoCompleteSetResult(modelname, value) {

                //var self = this;
                //var obj = self.formitems[modelname];

                //address.autoCompleteSetResult(obj, value, self.formitems.zipcode, self.formitems.country.value, self.formitems.city.value, self.formitems.state.value);

                var self = this;
                var obj = self.formitems[modelname];

                //close autocomplete box and set the selected value
                obj.isopen = false;
                obj.arrowcounter = -1;
                obj.value = value;

                //reset options to full list (in case user comes back to change the value)
                obj.search = obj.allvalues;

                if (self.formitems.country.value === 'US') {

                    //if the city is being set
                    if (obj.name === "Address.City") {

                        //get a list of zipcodes that are in city
                        address.getZipCodes(self.formitems.zipcode, self.formitems.city.value, self.formitems.state.value);

                        //if new city does not contain existing zipcode as option, blank it
                        if (self.formitems.zipcode.allvalues.indexOf(self.formitems.zipcode.value) === -1) {
                            self.formitems.zipcode.value = '';
                        }
                    }
                }
            },

            clickOutFilter: function clickOutFilter(e) {

                //var self = this;

                //address.clickOutFilter(e, self.formitems.city, self.formitems.zipcode);

                var self = this;

                self.debug("clickOutFilter() returned");

                var validElements = ['li', 'ul', 'input'];

                if (validElements.indexOf(e.target.tagName) === -1) {
                    self.formitems.city.isopen = false;
                    self.formitems.city.arrowCounter = -1;
                    self.formitems.city.search = self.formitems.city.allvalues;

                    self.formitems.zipcode.isopen = false;
                    self.formitems.zipcode.arrowcounter = -1;
                    self.formitems.zipcode.search = self.formitems.zipcode.allvalues;
                }

                if (self.formitems.country.value === 'US' && self.formitems.state.value.length > 0 && self.formitems.city.value.length > 0) {

                    address.getZipCodes(self.formitems.zipcode, self.formitems.city.value, self.formitems.state.value);
                }
            },

            autoCompleteTyping: function autoCompleteTyping(modelname) {

                var self = this;
                var obj = self.formitems[modelname];

                autocomplete.typing(obj);
            },

            autoCompleteArrowUp: function autoCompleteArrowUp(modelname) {

                var self = this;
                var obj = self.formitems[modelname];

                autocomplete.arrowUp(obj);
            },

            autoCompleteArrowDown: function autoCompleteArrowDown(modelname) {

                var self = this;
                var obj = self.formitems[modelname];

                autocomplete.arrowDown(obj);
            },

            autoCompleteTab: function autoCompleteTab(e, modelname) {

                var self = this;
                var obj = self.formitems[modelname];

                autocomplete.tab(e, obj);

                if (obj.name === "Address.City" && self.formitems.country.value === "US") {
                    address.getZipCodes(self.formitems.zipcode, self.formitems.city.value, self.formitems.state.value);
                }
            },

            autoCompleteEnter: function autoCompleteEnter(e, modelname) {

                var self = this;
                var obj = self.formitems[modelname];

                autocomplete.enter(e, obj);

                if (obj.name === "Address.City" && self.formitems.country.value === "US") {
                    address.getZipCodes(self.formitems.zipcode, self.formitems.city.value, self.formitems.state.value);
                }
            }
        }
    });
}(window.Contact.Controllers = window.Contact.Controllers || {}))